import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '@/store';
import layouts from '@/layouts/index.vue';
// import routerMap  from './routerMap'

const originalPush = VueRouter.prototype.push;

VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch((err) => err);
};

Vue.use(VueRouter);

const router = new VueRouter({
	// mode: 'history',
});

//路由初始化
const constantRouterComponents = {
	layouts: layouts,
	home: () => import('@/views/Home'),
	about: () => import('@/views/About'),
	business: () => import('@/views/Business'),
	technology: () => import('@/views/Technology'),
	brand: () => import('@/views/Brand'),
	joinKewei: () => import('@/views/JoinKewei'),
	news: () => import('@/views/news'),
};

// 导航
const rootRouter = [
	{
		path: '/',
		name: 'index',
		redirect: '/home',
		component: constantRouterComponents['layouts'],
		meta: { title: '首页' },
		children: [],
	},
];

// 设定路由
const generatorDynamicRouter = (res) => {
	return res.map((item) => {
		const currentRouter = {
			path: `${item.path}`,
			name: item.path,
			redirect: item.redirect || '',
			component:
				constantRouterComponents[item.component] ||
				(() => import(`@/views/${item.path}`)),
			meta: { title: item.name, id: item.id },
		};
		if (item.children && item.children.length > 0) {
			currentRouter.children = generatorDynamicRouter(item.children);
		}

		return currentRouter;
	});
};

// function addNewRute( routeName ){
//     return {
//       path: "/"+routeName,
//       name: routeName,
//       component: constantRouterComponents[routeName],
//       meta: {}
//     }
// }

// 获取路由并添加到
store.dispatch('router/GenerateRoutes').then(() => {
	rootRouter[0].children = generatorDynamicRouter(store.getters.addRouters);
	router.addRoutes(rootRouter);
});

// router.beforeEach((to, from, next) =>{
//   console.log(to,from,123)
//    next( vm =>{
//      console.log(vm,123456)
//    })
// })

export default router;
